export interface ErrorToastDefault {
  title: string;
  description: string;
}

export const fallbackErrorToast: ErrorToastDefault = {
  title: 'Something went wrong',
  description: 'Please try again later',
};

export const errorToastDefaultsByStatus: Record<number, ErrorToastDefault> = {
  400: {
    title: 'Something went wrong',
    description: 'Please check your input and try again',
  },
  401: {
    title: 'Session Expired',
    description:
      'You have been signed out due to inactivity, please log in again.',
  },
  403: {
    title: "You don't have permission to do that",
    description: 'Please try again later',
  },
  404: {
    title: 'Not found',
    description: 'The item you were looking for could not be found',
  },
  409: {
    title: 'Something went wrong',
    description: 'That conflicts with existing data',
  },
  422: {
    title: 'Something went wrong',
    description: 'Please check your input and try again',
  },
  429: {
    title: 'Too many requests',
    description: 'Please wait a moment and try again',
  },
  500: fallbackErrorToast,
  502: fallbackErrorToast,
  503: fallbackErrorToast,
};

export const getErrorToastDefaults = (code?: number | null): ErrorToastDefault =>
  (code && errorToastDefaultsByStatus[code]) || fallbackErrorToast;
